import { axios } from '@getgreenline/homi-shared'
import { CompaniesModels } from '@getgreenline/companies'

export interface IOrganizationWithCompanies {
  id: number
  name: string
  companies: Pick<CompaniesModels.ICompany, 'id' | 'name' | 'province'>[]
}

export const getOrganizationWithCompanies = (
  organizationId: number,
): Promise<IOrganizationWithCompanies> =>
  axios.get(`/api/v1/admin/organizations/${organizationId}`).then((r) => r.data)

export const removeCompanyFromOrganization = (
  organizationId: number,
  companyId: number,
): Promise<void> =>
  axios
    .delete(`/api/v1/admin/organizations/${organizationId}/migrations/${companyId}`)
    .then(() => undefined)
